import LinkTerminalComponent from '../Pages/TerminalOnboard/LinkTerminalComponent';
import UnlinkTerminalComponent from '../Pages/TerminalOnboard/UnlinkTerminalComponent';

const TerminalOnboarding = () => {
    return (
        <article className="docs-article" id="section-5">
            <header className="docs-header">
                <h1 className="docs-heading">Terminal Onboarding <span className="docs-time">Last updated: 2023-06-30</span>
                </h1>
                <section className="docs-intro">
                    <p>Terminal onboarding is the procedure where a terminal ID is connected to a physical terminal owned by a merchant. This connection enables merchants to use the terminal for conducting financial transactions. Once successfully onboarded, the terminal becomes an essential tool for merchants to process payments and manage sales. Furthermore, merchants have the flexibility to unlink a terminal from their account and assign a different terminal ID as needed, allowing for seamless adaptation to changes in their terminal infrastructure.</p>
                    <br />
                    <div className="docs-intro-section">
                        <h3>Terminal onboarding steps.</h3>
                        <br />
                        <img className="responsive" src="/assets/images/contents/TerminalLinking.png" alt="Terminal onboarding overview" style={{ marginBottom: "20px" }}></img>
                        <h3>Terminal onboarding flow diagram.</h3>
                        <br />
                        <img className="responsive" src="/assets/images/contents/CommisionFlow.png" alt="Terminal onboarding Flow" style={{ marginBottom: "20px" }}></img>
                        <br />
                    </div>
                    <div className="docs-intro-section">
                        <h3>Terminal unlinking steps.</h3>
                        <br />
                        <img className="responsive" src="/assets/images/contents/TerminalUnlinking.png" alt="Terminal unlink overview" style={{ marginBottom: "20px" }}></img>
                        <h3>Terminal unlinking flow diagram.</h3>
                        <br />
                        <img className="responsive" src="/assets/images/contents/UnlinkingFlow.png" alt="Terminal unlink Flow" style={{ marginBottom: "20px" }}></img>
                        <br />
                    </div>
                </section>
            </header>
            <LinkTerminalComponent />
            <UnlinkTerminalComponent />
        </article>
    );
};

export default TerminalOnboarding;